import { env } from 'core/constants/env.constants';

const DISCOVERY_PATH = '/.well-known/openid-configuration';
const REACHABILITY_TIMEOUT_MS = 5000;

const withoutTrailingSlash = (url: string): string => (url.endsWith('/') ? url.slice(0, -1) : url);

const isDiscoveryDocumentOf = (document: unknown, authority: string): boolean =>
  typeof document === 'object' &&
  document !== null &&
  'issuer' in document &&
  typeof document.issuer === 'string' &&
  withoutTrailingSlash(document.issuer) === authority;

export const isIdentityProviderReachable = async (): Promise<boolean> => {
  const authority = withoutTrailingSlash(env.VITE_AUTH_AUTHORITY);

  try {
    const response = await fetch(`${authority}${DISCOVERY_PATH}`, {
      cache: 'no-store',
      signal: AbortSignal.timeout(REACHABILITY_TIMEOUT_MS),
    });

    return response.ok && isDiscoveryDocumentOf(await response.json(), authority);
  } catch {
    return false;
  }
};
